import AccessControl from 'legacy/components/AccessControl/AccessControl'
import { Permission } from 'legacy/common/types'
import { type AccessControlConfig } from 'legacy/components/AccessControl/accessControl.utils'

export const AdminAccessControl: AccessControlConfig = {
  permissions: AccessControl.oneOf([Permission.ManageUsers, Permission.UserActivities]),
}
